// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Redux:
import { getPageData } from 'actions/page'

class PageHeader extends React.Component {
	constructor( props ) {
		super( props )
	}

	componentDidMount() {

	}

	renderLoading() {
		return (
			<div className="page-header page-header-is-loading">
				<div className="-inner">

				</div>
			</div>
		)
	}

	renderContent() {
		const { page, isLiked, shareLinkData } = this.props
		let title = page.title.rendered
		let titleRaw = page.title.raw
		let subTitle
		let image
		let intro

		if ( 'program-default' == page.slug ) {
			// Leave title blank while shareLinkData loads.
			title = ''
			titleRaw = ''

			if ( shareLinkData && shareLinkData.series ) {
				title = shareLinkData.series
				titleRaw = shareLinkData.series
			}
		}

		if ( 'event' == page.post_type ) {
			title = page.event_location
		}

		document.title = titleRaw

		const titleMarkup = (
			<h1>
				<span dangerouslySetInnerHTML={ { __html: title } } />

				{ isLiked &&
					<i className="icon-heart" aria-hidden="true" />
				}
			</h1>
		)

		let dateMarkup

		if ( 'post' == page.type && page.date ) {
			dateMarkup = (
				<p className="-date">{ page.date }</p>
			)
		} else if ( 'event' == page.post_type && page.event_date ) {
			dateMarkup = (
				<p className="-date">{ page.event_date }</p>
			)
		}

		return (
			<div className="page-header">
				<div className="-inner">
					<div className="-text">
						<div className="-title">
							{ titleMarkup }
							{ dateMarkup }
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		return (
			<div>
				{ this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		shareLinkData: state.site.shareLinkData
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( PageHeader )
